<template>
  <div>
    <PageHeader :title="pageHeader"></PageHeader>
    <div v-if="response">
      <v-alert
        type="error"
        v-if="response.errorcode > 0"
      >
        <div>Your transaction was Declined.</div>
        <div>Error Code: {{errorCode.errorCode}}</div>
        <div>Explanation: {{errorCode.explanation}}</div>
      </v-alert>
      <v-dialog
        v-model="dialogAlreadyActivated"
        scrollable
        overlay-opacity="0.9"
      >
        <v-card>
          <v-card-title>Transaction Processed</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="color:#ffffff;" class="honeyBold">
            <p v-if="paymentRequest !== ''">
              This transactions Entry has already been activated. You can access it from "My Entries"
            </p>
            <p v-if="paymentRequest === ''">
              Unable to find this payment request
            </p>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              color="fanhiveHoney"
              text
              @click="goToMyEntries"
            >
              Go to My Entries
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-overlay
        :absolute="false"
        :value="overlay"
        :opacity="0.9"
        >
        <v-progress-circular
          indeterminate
          color="amber"
          :size="70"
          :width="7"
        ></v-progress-circular>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import PageHeader from './../../components/PageHeader';
import jsonErrorCodes from './../../assets/tp-error-codes.json';
import _ from 'lodash';
import Socket from "./../../plugins/socket";

export default {
  name: 'transactions',
  data: () => ({ 
    overlay: false,
    paymentRequest: null,
    pageHeader: null,
    walletUpdateCount: 0,
    entryId: null,
    dialogAlreadyActivated: false,
    competition: null
  }),
  components: {
    PageHeader
  },
  computed: {
    result() {
      return this.$route.query.result;
    },
    response() {
      return {
        errorcode: parseInt(this.$route.query.errorcode),
        competitionId: this.$route.query.competitionId,
        paymentRequestId: this.$route.query.paymentRequestId,
        requestreference: this.$route.query.requestreference,
        transactionreference: this.$route.query.transactionreference,
        paymentNotRequired: this.$route.query.paymentNotRequired
      }
    },
    errorCode () {
      var scope = this;
      return _.find(jsonErrorCodes, function(o) { return o.errorCode === scope.response.errorcode; });
    },
    updatingWalletCredits () {
      return this.$store.getters.updatingWalletCredits;
    },
    updatingWalletHoneyPoints () {
      return this.$store.getters.updatingWalletHoneyPoints;
    },
    creatingEntry () {
      return this.$store.getters.creatingEntry;
    }
  },
  methods: {
    goToMyEntries: function () {
      this.$router.push({name: 'my-entries'});
    },
    getPaymentRequest: function (paymentRequestId) {
      var scope = this;
      this.overlay = true;
      this.$store.dispatch('getPaymentRequest', paymentRequestId).then(response => {
        scope.paymentRequest = response;
        console.log(scope.paymentRequest);
        if(scope.paymentRequest === '' || scope.paymentRequest.approved !== null){
          scope.overlay = false;
          scope.dialogAlreadyActivated = true;
        } else {
          scope.getCompetition(scope.response.competitionId);
        }
      }, error => {
          scope.overlay = false;
          console.log(error);
      });
    },
    updatePaymentRequest: function () {
      var scope = this;
      scope.overlay = true;
      scope.paymentRequest.approved = scope.response.errorcode === 0 ? true : false;
      scope.paymentRequest.errorDetails = `${scope.errorCode.explanation} (${scope.errorCode.errorCode})`;
      scope.paymentRequest.requestReference = scope.response.requestreference;
      scope.paymentRequest.transactionReference = scope.response.transactionreference;
      scope.paymentRequest.response = JSON.stringify(scope.$route.query);
      this.$store.dispatch('updatePaymentRequest', scope.paymentRequest).then(addPaymentRequestResponse => {
        console.log(`New Payment Request added [${addPaymentRequestResponse.id}]`);
        scope.paymentRequestId = addPaymentRequestResponse.id;
        scope.agreeAndStart();
      }, error => {
          console.log(error);
      });
    },
    getCompetition: function (competitionId) {
      var scope = this;
      this.overlay = true;
      this.$store.dispatch('getCompetition', competitionId).then(response => {
        scope.competition = response;
        scope.overlay = false;
        if(scope.response.errorcode === 0){
          console.log('Activating entry');
          scope.updatePaymentRequest();
        }
      }, error => {
          scope.overlay = false;
          console.log(error);
      });
    },
    reconnect: function () {
      var scope = this;
      console.log('Connectionid is null when agreeing and starting, must get new one.');
      Socket.connect(scope.$store.getters.userSub.userName);
      setTimeout(() => {
        scope.agreeAndStart();
      }, 2500);
    },
    agreeAndStart: function () {
      this.overlay = true;
      var scope = this;

      if(scope.$store.getters.connectionId === null){
        scope.reconnect();
        return;
      }

      this.walletUpdateCount = 0;
      this.entryId = null;
      scope.$store.commit('setUpdatingWalletCredits', 1);
      this.$store.dispatch('addWalletTransaction', {
      walletId: scope.$store.getters.wallet.id,
      isDebit: true,
      amount: scope.competition.entryCredits,
      notes: 'Entry'
    }).then(addWalletTransactionResponse => {
          console.log(`New wallet transaction added [${addWalletTransactionResponse.id}]`);

          scope.$store.commit('setCreatingEntry', 1);
          scope.$store.dispatch('addEntry', {
            userId: scope.$store.getters.userSub.id,
            competitionId: scope.competition.id,
            entryCredits: scope.competition.entryCredits
          }).then(addEntryResponse => {
            console.log(`New entry added [${addEntryResponse.id}]`);
            scope.entryId = addEntryResponse.id;
            
            scope.$store.commit('setUpdatingWalletHoneyPoints', 1);
            scope.$store.dispatch('addHoneyTransaction', {
                userId: scope.$store.getters.userSub.id,
                walletId: scope.$store.getters.wallet.id,
                entryId: addEntryResponse.id,
                isDebit: false,
                honeyPointSlug: 'entry'
              }).then(addHoneyTransactionResponse => {
                  console.log(`New honey transaction added [${addHoneyTransactionResponse.id}]`);
                }, error => {
                    console.log(error);
                });
            }, error => {
                console.log(error);
            });
          
        }, error => {
            console.log(error);
        });
    },
    updateWallet(){
      var scope = this;
      this.$store.dispatch('getWallet', this.$store.getters.userSub.id).then(response => {
          scope.$localStorage.set('wallet', JSON.stringify(response));
          scope.$store.commit('setWallet', response);
          scope.$store.commit('setUpdatingWalletCredits', 0);
          scope.$store.commit('setUpdatingWalletHoneyPoints', 0);
          scope.$store.commit('setCreatingEntry', 0);
          scope.overlay = false;
          scope.$router.push({name: 'questions', query: { 
            entryId: scope.entryId,
            sportId: scope.competition.sportId,
            totalQuestions: scope.competition.totalQuestions,
            paymentApproved: true,
            amount: scope.paymentRequest.amount,
            paymentNotRequired: scope.response.paymentNotRequired
          }});
        }, error => {
            console.log(error);
        })
    }
  },
  created () {
    this.pageHeader = this.response.errorcode === 0 ? '' : 'Payment Declined';
    this.getPaymentRequest(this.response.paymentRequestId);
  },
  watch: {
      updatingWalletCredits (newVal) {
        if(newVal === 2)
          this.walletUpdateCount = this.walletUpdateCount + 1;
      },
      updatingWalletHoneyPoints (newVal) {
        if(newVal === 2)
          this.walletUpdateCount = this.walletUpdateCount + 1;
      },
      creatingEntry (newVal) {
        if(newVal === 2)
          this.walletUpdateCount = this.walletUpdateCount + 1;
      },
      walletUpdateCount (newVal) {
        console.log(newVal);
        if(newVal === 3) {
          this.updateWallet();
        }
      }
  }
}
</script>